import React from 'react';
import './Sponsorship.css';

function Sponsorship() {
  return (
    <div className="sponsorship-page">
      <div className="sponsorship-hero">
        <h1 className="sponsorship-title">Become a <span className="highlight-text">Sponsor</span></h1>
        <p className="sponsorship-subtitle">Partner with ThrillArts to empower the next generation of creators, gamers, and artists.</p>
      </div>

      <div className="sponsorship-content">
        <section className="sponsorship-info-section">
          <h2>Why Sponsor ThrillArts?</h2>
          <p>
            At ThrillArts, we are pushing the boundaries of creativity through music, games, AI, digital art, and virtual experiences. 
            By sponsoring us or our creators, you gain exclusive access to a passionate and highly engaged audience.
          </p>
          <div className="benefits-grid">
            <div className="benefit-card">
              <h3>🌍 Global Reach</h3>
              <p>Connect your brand with creators and fans across multiple industries globally.</p>
            </div>
            <div className="benefit-card">
              <h3>🚀 Innovative Campaigns</h3>
              <p>Leverage our Metaverse, virtual tours, and custom software for unique marketing opportunities.</p>
            </div>
            <div className="benefit-card">
              <h3>🤝 Empower Creators</h3>
              <p>Directly support independent artists, developers, and musicians in achieving their dreams.</p>
            </div>
          </div>
        </section>

        <section className="sponsorship-application">
          <h2>Apply for Sponsorship</h2>
          <p>Interested in becoming a sponsor or seeking sponsorship for your creative project? Get in touch with us!</p>
          
          <form className="sponsorship-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-group">
              <label htmlFor="name">Full Name or Company Name</label>
              <input type="text" id="name" placeholder="Enter your name" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" placeholder="Enter your email" required />
            </div>
            <div className="form-group">
              <label htmlFor="type">Sponsorship Interest</label>
              <select id="type" required>
                <option value="">Select an option</option>
                <option value="become_sponsor">I want to become a sponsor</option>
                <option value="seek_sponsor">I am seeking sponsorship</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="message">Tell us more</label>
              <textarea id="message" rows="5" placeholder="Describe your brand, project, or sponsorship goals..." required></textarea>
            </div>
            <button type="submit" className="submit-btn">Submit Application</button>
          </form>
          <p className="contact-alternative">Alternatively, email us at <a href="mailto:contact@thrillarts.com">contact@thrillarts.com</a> or call <a href="tel:404-914-6066">404-914-6066</a>.</p>
        </section>
      </div>
    </div>
  );
}

export default Sponsorship;
